import { gql, useQuery } from '@apollo/client';
import _ from 'lodash';
import { FunctionComponent, SyntheticEvent } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMount } from 'react-use';
import FaqBlock from '~components/faq/Faq';
import { useConfig } from '~components/hooks';
import { Loader } from '~components/Loader';
import { useYaMetrica } from '~frontend/provider/yametrica';
import { Faq as FaqType } from '~types';

import '../../scss/pages/_faq.scss';

function useQuerys() {
  return new URLSearchParams(useLocation().search);
}

interface FaqData {
  getFaqs: FaqType[];
}

const Faq: FunctionComponent = () => {
  const getConfig = useConfig();
  const navigate = useNavigate();
  const query = useQuerys();

  const { loading, error, data } = useQuery<FaqData>(gql`
    query Faq {
      getFaqs {
        id
        images
        imagesHover
        data
      }
    }
  `);

  const { t } = useTranslation();

  const { reachGoal } = useYaMetrica();

  useMount(() => {
    reachGoal('goPageFaq');
  });

  const goPage = (event: SyntheticEvent<HTMLDivElement>) => {
    const el = (event.target as Element).parentElement;

    const href = el.getAttribute('href');

    if (_.includes(href, getConfig?.hostname.split('.')[0])) {
      event.preventDefault();

      navigate((el as HTMLAreaElement).pathname);
    }
  };

  if (loading) {
    return <Loader />;
  } else if (error) {
    return <>Faq | Error! {error.message}</>;
  }

  const { getFaqs } = data;

  return (
    <>
      <Helmet>
        {getConfig?.isEU ? (
          <title>{t('faq_title_seo_com')}</title>
        ) : (
          <title>{t('faq_title_seo_io')}</title>
        )}
        {getConfig?.isEU ? (
          <meta name="description" content={t('faq_desc_seo_com')} />
        ) : (
          <meta name="description" content={t('faq_desc_seo_io')} />
        )}
      </Helmet>
      <div className="page-faq">
        <FaqBlock faqData={getFaqs} goPage={goPage} />
      </div>
    </>
  );
};

export default Faq;
